import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from "../../../constants/pages-and-paths";
import {AuthGuardService} from "../../../guards/auth-guard.service";
import {CompanySubscriptionComponent} from "./company-subscription.component";

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.companySubscription.pageInRouting,
    data: {data: PAGES_AND_PATHS.companySubscription},
    component: CompanySubscriptionComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./company-subscription.module').then(m => m.CompanySubscriptionModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompanySubscriptionRoutingModule { }
